<div class="flex-row mapping-list">
    <ng-container *ngrxLet="segObjectPropertyMaps$ as segObjectPropertyMaps">
        <ng-container *ngrxLet="loadedSegObjectPropertyMaps$ as loadedMaps">
            <div class="mapping-dropdown" #dropdownRoot>
                <label class="mapping-list-label">Intensity Maps</label>
                <button
                    type="button"
                    class="mapping-dropdown-trigger"
                    [class.open]="dropdownOpen"
                    [disabled]="!segObjectPropertyMaps?.length"
                    (click)="toggleDropdown($event)"
                    [attr.aria-expanded]="dropdownOpen"
                    aria-haspopup="listbox"
                >
                    <span class="mapping-dropdown-label">{{
                        getSelectionLabel(loadedMaps, segObjectPropertyMaps)
                    }}</span>
                    <cds-icon shape="angle" [direction]="dropdownOpen ? 'up' : 'down'"></cds-icon>
                </button>
                <div *ngIf="dropdownOpen" class="mapping-dropdown-panel" role="listbox">
                    <ul class="mapping-checkboxes">
                        <li *ngFor="let segobjectmap of segObjectPropertyMaps">
                            <cds-checkbox
                                [attr.title]="
                                    getMapDisabledTitle(segobjectmap, loadedMaps) ?? undefined
                                "
                                [class.disabled-by-seg-source]="
                                    isMapDisabled(segobjectmap, loadedMaps)
                                "
                            >
                                <label>{{ segobjectmap.name }}</label>
                                <input
                                    type="checkbox"
                                    [checked]="isMapLoaded(segobjectmap.id, loadedMaps)"
                                    [disabled]="isMapDisabled(segobjectmap, loadedMaps)"
                                    (change)="
                                        toggleSegObjectPropertyMap(
                                            segobjectmap,
                                            isMapLoaded(segobjectmap.id, loadedMaps)
                                        )
                                    "
                                />
                            </cds-checkbox>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
